import { parseAsStringEnum, useQueryState } from 'nuqs';

const options = parseAsStringEnum(['doctor', 'nurse', 'support']);

export const useChatRoleSelection = () => {
  const [selectedChatRole, setSelectedChatRole] = useQueryState('pscr', options);

  return { selectedChatRole, setSelectedChatRole };
};
